<template>
<div>
  <div style="height: 40px;margin: 0 50px" v-if="$store.state.user.moduletag !== 2">
    <div :class="item.index === indexActive ? 'select-active' : 'no-select'" v-for="item in tabs" :key="item.index" @click="selectTab(item)">
      <span>{{item.name}}</span>
    </div>
  </div>
  <div>
    <div v-if="indexActive === 0" style="font-size: 16px;color: #606266;margin: 0 40px">
      <el-row>
        <el-col :span="12">
          <div class="left-name">
            <span>报警类型：</span>
          </div>
          <div class="right-show-name">
            <span>{{getAType(details.row)}}</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="left-name">
            <span>报警时间：</span>
          </div>
          <div class="right-show-name">
            <span>{{details.row.time}}</span>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div class="left-name">
            <span>服务对象：</span>
          </div>
          <div class="right-show-name">
            <span>{{details.row.p_name}}</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="left-name">
            <span>性别：</span>
          </div>
          <div class="right-show-name">
            <span>{{getSex(details.row.p_sex)}}</span>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div class="left-name">
            <span>设备编号：</span>
          </div>
          <div class="right-show-name">
            <span v-if="details.row.device">{{details.row.device.deviceid}}</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="left-name">
            <span>设备类型：</span>
          </div>
          <div class="right-show-name">
            <span v-if="details.row.device">{{getDeviceType(details.row)}}</span>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div class="left-name">
            <span>设备电话：</span>
          </div>
          <div class="right-show-name">
            <span v-if="details.row.device">{{details.row.device.simcardno}}</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="left-name">
            <span>安装位置：</span>
          </div>
          <div class="right-show-name">
            <span>{{details.row.h_install_location}}</span>
          </div>
        </el-col>
      </el-row>
      <el-row v-if="$store.state.user.moduletag !== 2">
        <el-col :span="24">
          <div class="left-name">
            <span>家庭地址：</span>
          </div>
          <div class="right-show-name">
            <span>{{details.row.h_address}}</span>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="left-name">
            <span>处理情况：</span>
          </div>
          <div class="right-show-name">
            <span>{{getIsHandle(details.row)}}</span>
          </div>
        </el-col>
      </el-row>
      <div style="clear: both"></div>
      <div style="max-height: 300px;overflow-y: auto">
        <el-table size="mini" v-loading="loading" element-loading-text="加载中，请耐心等待。" :data="showHandleTable"
            border style="width: 100%" highlight-current-row ref="singleTable">
          <el-table-column
              type="index"
              label="序号"
              width="70"
              align="center">
          </el-table-column>
          <el-table-column
              prop="content"
              label="处理详情"
              min-width="120"
              align="center">
          </el-table-column>
          <el-table-column
              prop="handletime"
              label="处理时间"
              min-width="140"
              align="center">
          </el-table-column>
          <el-table-column
              prop="customerservicename"
              label="处理人员"
              min-width="100"
              align="center">
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div v-if="indexActive === 1">
      <service-object-alarm :serviceObj="serviceObj"></service-object-alarm>
    </div>
    <div v-if="indexActive === 2">
      <home-details :homeObj="homeObj"></home-details>
    </div>
    <div style="height: 30px"></div>
  </div>
</div>
</template>

<script>
import serviceObjectAlarm from '../../handlealarm/childComponents/serviceObjectAlarm'
import homeDetails from './homeDetails'
import {queryhomebyhids, queryoldpersonbypids, queryoldpersonbyhids, queryalarmhandle} from '../../../api/handlealarm'

export default {
  name: 'alarmDetailsNew',
  components: {serviceObjectAlarm, homeDetails},
  model: {
    prop: 'alarmShow',
    event: 'change'
  },
  props: {
    details: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      tabs: [{index: 0, name: '报警详情'}],
      indexActive: 0,
      serviceObj: {
        projects: [],
        frequencys: [],
        alarmRow: '',
        alarmDidRow: '',
        oldperson: ''
      },
      homeObj: {
        alarmDidRow: '',
        home: '',
        familypersons: [],
        orgcommunitys: [],
        oldperson: []
      },
      hids: [],
      pids: [],
      loading: false,
      showHandleTable: []
    }
  },
  created () {
    // alarmService.vue事件/服务统计 详情 按钮
    console.log('details', this.details)
    this.getAlarmsHistory()
    this.serviceObj.projects = this.details.projects
    this.serviceObj.frequencys = this.details.frequencys
    if (this.details.row.device) {
      if (this.details.row.device.devicetype === 700) {
        this.hids = [this.details.row.device.hid]
        this.tabs = [
          {index: 0, name: '报警详情'},
          {index: 2, name: '家庭信息'}
        ]
        this.getHomeData()
        this.getOldPersonByHome()
      } else if (this.details.row.device.devicetype === 300 || this.details.row.device.devicetype === 901 || this.details.row.device.devicetype === 350) {
        this.pids = [this.details.row.device.pid]
        this.tabs = [
          {index: 0, name: '报警详情'},
          {index: 1, name: '服务对象信息'},
          {index: 2, name: '家庭信息'}
        ]
        this.getOldPerson()
      }
    } else { // 电话呼入
      if (this.details.row.p_pid > 0) {
        this.pids = [this.details.row.p_pid]
        this.tabs = [
          {index: 0, name: '报警详情'},
          {index: 1, name: '服务对象信息'},
          {index: 2, name: '家庭信息'}
        ]
        this.getOldPerson()
      } else if (this.details.row.h_hid > 0) {
        this.hids = [this.details.row.h_hid]
        this.tabs = [
          {index: 0, name: '报警详情'},
          {index: 2, name: '家庭信息'}
        ]
        this.getHomeData()
        this.getOldPersonByHome()
      }
    }
    this.serviceObj.alarmDidRow = this.details.row
    this.homeObj.alarmDidRow = this.details.row
    this.homeObj.orgcommunitys = this.details.orgcommunitys
  },
  methods: {
    getAlarmsHistory () {
      this.loading = true
      let data = {
        aids: [this.details.row.id]
      }
      queryalarmhandle(data).then(res => {
        this.showHandleTable = res.data.alarmhandle
        this.loading = false
      }).catch(() => {})
    },
    // 家信息
    getHomeData () {
      let data = {
        hids: this.hids
      }
      queryhomebyhids(data).then(res => {
        this.homeObj.home = res.data.homes[0]
      }).catch(() => {})
    },
    // 家庭查家庭成员
    getOldPersonByHome () {
      let data = {
        hids: this.hids
      }
      queryoldpersonbyhids(data).then(res => {
        this.homeObj.oldperson = res.data.persons
      }).catch(() => {})
    },
    // 服务对象信息
    getOldPerson () {
      let data = {
        pids: this.pids
      }
      queryoldpersonbypids(data).then(res => {
        this.serviceObj.oldperson = res.data.persons[0]
        this.hids = [this.serviceObj.oldperson.homeid]
        this.getHomeData()
        this.getOldPersonByHome()
      }).catch(() => {
      })
    },
    selectTab (item) {
      this.indexActive = item.index
    },
    getSex (sex) {
      return this.util.getSex(sex + '')
    },
    getDeviceType (row) {
      let type = 0
      if (row.device) {
        type = row.device.devicetype
      }
      if (this.$store.state.user.moduletag === 2) {
        if (type === 700) {
          return '智能网关'
        }
      }
      return this.commonType.getDeviceType(type)
    },
    getIsHandle (row) {
      let handle = ''
      if (row.ishandle === 1) {
        handle = '已处理'
      } else if (row.ishandle === 0) {
        handle = '未处理'
      }
      return handle
    },
    getAType (row) {
      return this.commonType.getAlarmType(row.alarmtype)
    }
  }
}
</script>

<style scoped>
  .left-name{
    margin-top: 6px;
    width: 100px;
    float: left;
    text-align: right
  }
  .right-show-name{
    margin-top: 6px;
    width: calc(100% - 101px);
    float: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/statisticalform/childComponents/alarmDetailsNew.vue